import { useTranslation } from 'react-i18next';
import { API } from '../../../API';
import { showRequestError } from '../../../utils/requestError';
import Async from 'react-select/async';
import { useEffect, useState, useCallback, startTransition } from 'react';

export const CountryChooser = ({onChange, selected = [], onClose}) => {
  const { t } = useTranslation();
  const [countries, setCountries] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [defaultOptions, setDefaultOptions] = useState([]);

  const handleInputChanged = (input, { action }) => {
    if (action === "set-value") {
      return;
    }

    setDefaultOptions([]);
    setSearchKey(input);
  };

  const getAllCountries = useCallback(() => {
    API.fetch('GET', `/API/v1/countries`).then((data) => {
      setCountries(data.objects.slice(0, 10).map(country => {return {value: country.id, label: country.name}}))
    }).catch((e) => showRequestError(e, t('Countries')));
  }, []);

  useEffect(getAllCountries, [getAllCountries]);
  

  const getCountries = (inputValue, callback) => {
    return API.fetch('GET', `/API/v1/countries?q=${inputValue}`).then((data) => {
      let optionsList = data.objects
        .map((source) => {
          return {value: source.id, label: source.name};
        })
        setDefaultOptions(optionsList)
      callback(
        optionsList
      );
    }).catch((e) => showRequestError(e, t('Countries')));
  };

  let countriesPromiseTimeout;
  const countriesPromiseOptions = function (inputValue) {
    if (countriesPromiseTimeout !== null) {
      clearTimeout(countriesPromiseTimeout);
    }

    if (! inputValue) {
        return [];
    }

    return new Promise((resolve) => {
      countriesPromiseTimeout = setTimeout(() => {
        getCountries(inputValue, resolve);
      }, 1000);
    });
  }

  if (!countries) return

  return(
    <div className='chooser country-search-filter'>
      <Async
        className="select-filter"
        classNamePrefix="select-filter"
        cacheOptions
        defaultOptions={searchKey ? defaultOptions : countries}
        isMulti={true}
        loadOptions={countriesPromiseOptions}
        placeholder={t('Please enter at least 1 symbol')}
        noOptionsMessage={()=> t('Please enter at least 1 symbol')}
        loadingMessage={() => t('Loading...')}
        name="countries"
        value={selected}
        onChange={(values) => {
          startTransition(() => onChange(values));
          setSearchKey("");
        }}
        onMenuClose={() => onClose()}
        closeMenuOnSelect={false}
        blurInputOnSelect={false}
        inputValue={searchKey}
        onInputChange={handleInputChanged}

      />
    </div>
  )
}